import { Link } from "react-router-dom";
import { useMall } from "@/context/MallContext";

/** One line. The shop, how to reach it, and the two links a shopper in the designer might need. */
export default function SlimFooter() {
    const { store } = useMall();
    const bits = [store?.name || "13thav", store?.phone, store?.address || store?.city].filter(Boolean);
    return (
        <footer className="flex h-10 items-center justify-between gap-4 border-t border-zinc-200 bg-white px-4 text-[11px] text-zinc-500 sm:px-6" data-testid="slim-footer">
            <p className="truncate">© {new Date().getFullYear()} {bits.join(" · ")}</p>
            <nav className="flex shrink-0 items-center gap-4">
                <Link to="/track" className="hover:text-zinc-900" data-testid="slim-footer-track">Track an order</Link>
                <Link to="/artwork-request" className="hover:text-zinc-900" data-testid="slim-footer-artwork">Artwork help</Link>
                <Link to="/whitelabel" className="hover:text-zinc-900" data-testid="slim-footer-13thav">Website by 13thav</Link>
            </nav>
        </footer>
    );
}
